import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shopPromiseLabel: {
    description: 'Premium program tag label for the ShopPromise program',
    defaultMessage: 'Promise',
    id: '3Kk+qt',
  },
  walmartSimplifiedShippingLabel: {
    description: 'Premium program tag label for the Walmart Simplified Shipping program',
    defaultMessage: 'Simplified Shipping',
    id: 'DsD5sO',
  },
  temuPreSaleLabel: {
    description: 'Premium program tag label for the Temu Pre-Sale program',
    defaultMessage: 'Pre-Sale',
    id: '+F67P/',
  },
  temuMadeToOrderLabel: {
    description: 'Premium program tag label for the Temu Made-to-Order program',
    defaultMessage: 'MTO',
    id: '3+3dy8',
  },
  tiktokExpressShippingLabel: {
    description: 'Premium program tag label for the TikTok Express Shipping program',
    defaultMessage: 'Express',
    id: 'vXnmAp',
  },
});
